<!-- 厂务概算制定 -->
<div class="main" *ngIf="makeBudgetEstimatesStatus">
  <div class="projectType">
    <h4>{{ 'Budgets.ProjectCategory' | translate }}</h4>
    <ng-container *ngIf="editBudgetEstimatesStatus; else elseRadioValue">
      <nz-list nzBordered>
        <nz-list-item>
          <nz-radio-group [ngModel]="radioValue" (ngModelChange)="nzRadioChange($event)"
            [nzDisabled]="reviewResultIsReject">
            <label nz-radio nzValue='0' style="font-weight:normal">{{ 'Budgets.GeneralEngineering' | translate }}</label>
            <label nz-radio nzValue='1' style="font-weight:normal">{{ 'Budgets.ProjectEngineering' | translate }}</label>
          </nz-radio-group>
        </nz-list-item>
      </nz-list>
    </ng-container>
    <ng-template #elseRadioValue>
      <nz-list nzBordered>
        <nz-list-item>
          <nz-radio-group [(ngModel)]="radioValue">
            <label *ngIf="radioValue === '0'" nz-radio nzValue='0' style="font-weight:normal">{{ 'Budgets.GeneralEngineering' | translate }}</label>
            <label *ngIf="radioValue === '1'" nz-radio nzValue='1' style="font-weight:normal">{{ 'Budgets.ProjectEngineering' | translate }}</label>
          </nz-radio-group>
        </nz-list-item>
      </nz-list>
    </ng-template>
  </div>
  <div class="bid-title">
    <!-- 标单详情 -->
    <h4>{{ 'Budgets.BidDetails' | translate }}<em nz-icon nzType="caret-down" nzTheme="outline" (click)="isVisible = !isVisible"></em></h4>
  </div>
  <div class="bidInfo">
    <nz-tabset nzType="card" class="card">
      <!-- 标单 -->
      <nz-tab *ngFor="let item of bidType" nzTitle="{{item.text}} {{'Budgets.Bid' | translate}}">
        <div *ngIf="isVisible">
          <ng-container>
            <ng-container *ngIf="bidInfo[item.value]['bidSaveData'] !== undefined; else elseTemplate2">
              <!-- button -->
              <div class="bid">
                <div class="btn-group2" *ngIf="(editBudgetEstimatesStatus && !reviewResultIsReject)  || isDownLoadBid">
                  <button nz-button nzType="primary" (click)="downloadBudgetOrBid(item.value)">{{ 'Budgets.Download' | translate }}</button>
                  <ng-container *ngIf="editBudgetEstimatesStatus && !reviewResultIsReject">
                    <button nz-button nzType="primary" (click)="saveBudgetOrBid(item.value)">{{ 'Budgets.Save' | translate }}</button>
                    <button *ngIf="radioValue !== '1'" nz-button nzType="primary" (click)="produceBudgetOrBid()">{{ produceText }}</button>
                  </ng-container>
                </div>
                <!-- 标单内容 -->
                <div class="bid-content" id="bidContent">
                  <!-- 标单头部:title button -->
                  <div class="bid-head">
                    <h3>{{ title }}</h3>
                  </div>
                  <!-- 标单form -->
                  <app-bid-form [editBudgetEstimatesStatus]="editBudgetEstimatesStatus"
                    [reviewResultIsReject]="reviewResultIsReject" [formContent]="formContent"
                    [bidBaseInfor]="bidInfo[item.value]['bidSaveData']['bidBaseInfor']"
                    (formChanged)="formChanged($event,item.value)">
                  </app-bid-form>
                  <!-- 标单table-->
                  <app-bid-table [produceBudgetStatus]="produceBudgetStatus"
                    [reviewResultIsReject]="reviewResultIsReject"
                    [makeBudgetEstimatesStatus]="makeBudgetEstimatesStatus"
                    [editBudgetEstimatesStatus]="editBudgetEstimatesStatus" [step]="step"
                    [getProjectCategory]="getProjectCategory" [selectColumns]="selectColumns"
                    [table2Columns]="table2Columns" [getFormBudgetCharge]="getFormBudgetCharge"
                    [bidBaseInfor]="bidInfo[item.value]['bidSaveData']['bidBaseInfor']"
                    [listOfTable1Data]="bidInfo[item.value]['listOfTable1Data']"
                    [listOfBaseMaterialData]="bidInfo[item.value]['listOfBaseMaterialData']"
                    [table2TotalPrice]="table2TotalPrice[item.value]" [profitTotalPrice]="profitTotalPrice[item.value]"
                    [taxRatesTotalPrice]="taxRatesTotalPrice[item.value]"
                    [table1TotalPrice]="table1TotalPrice[item.value]"
                    (selectValueChange)="selectValueChange($event,item.value)"
                    (table1ScaleChanged)="table1ScaleChanged($event,item.value)"
                    (table1RemarkChanged)="table1RemarkChanged($event,item.value)"
                    (itemChange)="itemChange($event,item.value)"
                    (remarkSelectChange)="remarkSelectChange($event,item.value)" (addRow)="addRow($event,item.value)"
                    (delRow)="delRow($event,item.value)" (addList)="addList($event,item.value)"
                    (delList)="delList($event,item.value)">
                  </app-bid-table>
                </div>
              </div>
            </ng-container>
            <ng-template #elseTemplate2>
              <h4 style="text-align: center;float: none;">
                {{ 'Budgets.WaitingVendorBid1' | translate }}[{{ item.text }} {{ 'Budgets.Vendor' | translate }}]{{ 'Budgets.WaitingVendorBid2' | translate }}
              </h4>
            </ng-template>
          </ng-container>
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</div>